var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownLang = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2862 0.000151193C1.08523 0.000151193 0.881311 0.078324 0.728874 0.230763C0.423709 0.535929 0.423709 1.04054 0.728874 1.3457L6.43926 7.05609C6.58665 7.20348 6.79458 7.2867 6.99659 7.2867C7.19669 7.2867 7.39613 7.21387 7.55391 7.05609L13.2565 1.35302C13.576 1.05235 13.5801 0.535831 13.2749 0.230665C12.9697 -0.0745004 12.4651 -0.0745004 12.1599 0.230665L12.1598 0.230856L7.00679 5.39407L1.84333 0.230612C1.6906 0.0778876 1.48669 0 1.286 0L1.2862 0.000151193Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownLang);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_down_lang.26e4aae2219428538790542dc7631a5f.svg";